import { useState } from "react";
import { FalloutCharacter, FalloutCharacterStatus, FalloutPlayer } from "../Data/Response";

type SupportingFireArgs = {
    player: FalloutPlayer;
    actor: FalloutCharacter;
    setSupport: React.Dispatch<React.SetStateAction<FalloutCharacter[]>>
}
const SupportingFireView: React.FC<SupportingFireArgs> = (args) => {
    const [supportingPCs, setSupportingPCs] = useState<string[]>([]);

    return <div>
        <h2>Add support?</h2>
        <ul>
            {args.player.crew?.characters.filter(pc => (
                pc.id !== args.actor.id &&
                pc.state.status === "active" &&
                pc.state.fatigue < 2
            )).map(pc => {
                return <li>
                    {pc.name}
                    <input
                        type="checkbox"
                        checked={supportingPCs.includes(pc.id)}
                        onChange={e => {
                            setSupportingPCs(pcs => {
                                if (pcs.includes(pc.id)) {
                                    return pcs.filter(id => id !== pc.id);
                                }
                                return [...pcs, pc.id];
                            });
                        }}
                    />
                </li>
            })}</ul>
        <button
            onClick={e => {
                args.setSupport(args.player.crew.characters.filter(pc => supportingPCs.includes(pc.id)));
            }}
        >Continue</button>
    </div>
}

export default SupportingFireView;